// This file is no longer being used directly
// The ActionCable subscription is now created directly in the view
// to avoid asset pipeline issues

import consumer from './consumer'

/**
 * Update the UI when a Plaid report is ready
 */
function updateUIForReportReady() {
  // Hide loading button
  const loadingButton = document.querySelector('#plaid-loading-button')
  if (loadingButton) {
    loadingButton.style.display = 'none'
  }

  // Update skip button to continue
  const skipButton = document.querySelector('#plaid-skip-button')
  if (skipButton) {
    skipButton.textContent = 'Continue'
    skipButton.classList.remove('btn-secondary')
    skipButton.classList.add('btn-primary')
    skipButton.disabled = false
  }

  // Update ALL paragraphs with generating text - not just ones with the class
  const allParagraphs = document.querySelectorAll('p')
  let foundStatus = false

  allParagraphs.forEach(p => {
    // Check if this is a status paragraph
    if (
      p.textContent.includes('generating') ||
      p.textContent.includes('report') ||
      p.textContent.includes('connecting')
    ) {
      if (!foundStatus) {
        // Update the first one to show success
        p.textContent = 'Account Connection Successful!'
        p.classList.add('plaid-status-message')
        foundStatus = true
      } else {
        // Hide any additional status paragraphs
        p.style.display = 'none'
      }
    }
  })
}

/**
 * Update the UI when a Plaid report fails
 */
function updateUIForReportFailed() {
  // Hide loading button
  const loadingButton = document.querySelector('#plaid-loading-button')
  if (loadingButton) {
    loadingButton.style.display = 'none'
  }

  // Update skip button to continue
  const skipButton = document.querySelector('#plaid-skip-button')
  if (skipButton) {
    skipButton.textContent = 'Continue'
    skipButton.classList.remove('btn-secondary')
    skipButton.classList.add('btn-primary')
    skipButton.disabled = false
  }

  // Update ALL paragraphs with generating text - not just ones with the class
  const allParagraphs = document.querySelectorAll('p')
  let foundStatus = false

  allParagraphs.forEach(p => {
    // Check if this is a status paragraph
    if (
      p.textContent.includes('generating') ||
      p.textContent.includes('report') ||
      p.textContent.includes('connecting')
    ) {
      if (!foundStatus) {
        // Update the first one to show error
        p.textContent = "We couldn't generate your report, but you can continue."
        p.classList.add('plaid-status-message')
        foundStatus = true
      } else {
        // Hide any additional status paragraphs
        p.style.display = 'none'
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  const userIdElement = document.getElementById('user-plaid-channel')
  if (!userIdElement) {
    return
  }

  const userId = userIdElement.getAttribute('data-plaid-channel-user-id')
  if (!userId) {
    return
  }

  consumer.subscriptions.create(
    { channel: 'PlaidReportStatusChannel', user_id: userId },
    {
      connected() {
        // Connection established
      },

      disconnected() {
        // Connection lost
      },

      rejected() {
        // Connection rejected
      },

      received(data) {
        if (data.status === 'report_ready') {
          updateUIForReportReady()
        } else if (data.status === 'report_failed') {
          updateUIForReportFailed()
        }
      },
    }
  )
})
